<!-- 「更新が完了しました」等のメッセージを出力する -->
<template>
    <div id="overlay" >
        <div id="content_modal">
            <template v-if="nittei_sentaku == 0">
                <div style="padding:10px;text-align:center">
                    <b> {{ DateSetting(clicked) }}</b><br>
                    <template v-if="teiin_settei == 1">
                    <!--
                    if="(taiken_list.teiin_oneday - result.ninzu) <= 0"
                    (result.teiin - result.ninzu) <= 0
                    -->
                        <template v-if="teiin_oneday >= 999">定員なし</template>
                        <template v-else-if="(teiin_oneday - sentaku_list[0].ninzu > 0)">
                            &nbsp;&nbsp;あと&nbsp;{{ teiin_oneday - sentaku_list[0].ninzu   }}人
                        </template>
                        <template v-else>
                            <template v-if="cancel_setting == 0">
                                &nbsp;&nbsp;<span style="color:red">キャンセル待ち </span>
                                <template v-if="(sentaku_list[0].ninzu - teiin_oneday) > 0">
                                    &nbsp;&nbsp; {{(sentaku_list[0].ninzu - teiin_oneday)}}人
                                </template>
                            </template>
                            <template v-else>
                                &nbsp;&nbsp;満員
                            </template>
                        </template>
                    </template>
                </div>
                <div v-for="(sentaku_row , i) in sentaku_list" v-bind:key="i" class="select_row">
                    <div style="width:85%">
                        {{ TimeSetting(sentaku_row.jikantai_start) }}～{{ TimeSetting(sentaku_row.jikantai_end) }}
                        <template v-if="teiin_settei == 0">
                            <template v-if="sentaku_row.teiin >= 999">定員なし</template>
                            <template v-else-if="(sentaku_row.teiin - sentaku_row.ninzu > 0)">
                                &nbsp;&nbsp;あと&nbsp;{{ sentaku_row.teiin - sentaku_row.ninzu  }}人
                            </template>
                            <template v-else>
                                <template v-if="cancel_setting == 0">
                                    &nbsp;&nbsp;<span style="color:red">キャンセル待ち </span> 
                                    <template v-if="(sentaku_row.ninzu - sentaku_row.teiin  ) > 0">
                                    &nbsp;&nbsp; {{(sentaku_row.ninzu - sentaku_row.teiin) }}人
                                    </template>
                                </template>
                                <template v-else>
                                    &nbsp;&nbsp;満員
                                </template>
                            </template>
                        </template>
                    </div>
                    <div>
                        <span v-if="mode != 'nologin' && mode != 'noinfo'">
                            <button v-if="sentaku_row.sentaku_flg == 0" class="btn btn-primary btn_confirm check_button" v-on:click="Check(i)">
                                選択
                            </button>
                            <button v-else-if="sentaku_row.sentaku_flg == 1" class="btn btn-secondary btn_confirm check_button" v-on:click="Check(i)">
                                取消
                            </button>
                        </span>
                    </div>
                </div>
            </template>
            <template v-else>
                <div style="padding:10px;text-align:center">
                    <b> {{ DateSetting(set_nittei_list.kaisai_start) }}～{{ DateSetting(set_nittei_list.kaisai_end) }}</b><br>
                    <template v-if="sentaku_list[0].teiin >= 999">定員なし</template>
                    <template v-else-if="(sentaku_list[0].teiin - sentaku_list[0].ninzu > 0)">
                        &nbsp;&nbsp;あと&nbsp;{{ sentaku_list[0].teiin - sentaku_list[0].ninzu }}人
                    </template>
                    <template v-else>
                        <template v-if="cancel_setting == 0">
                            &nbsp;&nbsp;<span style="color:red">キャンセル待ち </span> 
                            <template v-if="(sentaku_list[0].ninzu - sentaku_list[0].teiin  ) > 0">
                            &nbsp;&nbsp; {{ (sentaku_list[0].ninzu - sentaku_list[0].teiin) }}人
                            </template>
                        </template>
                        <template v-else>
                        &nbsp;&nbsp;満員
                        </template>
                    </template>
                </div>
                <div  class="select_row">

                    {{ TimeSetting(sentaku_list[0].jikantai_start) }}～{{ TimeSetting(sentaku_list[0].jikantai_end) }}
           
                    <span v-if="mode != 'nologin' && mode != 'noinfo'">
                        <button v-if="sentaku_list[0].sentaku_flg == 0" class="btn btn-primary btn_confirm check_button" v-on:click="Check_list()">
                            選択
                        </button>
                        <button v-else-if="sentaku_list[0].sentaku_flg == 1" class="btn btn-secondary btn_confirm check_button" v-on:click="Check_list()">
                            取消
                        </button>
                    </span>
                </div>
            </template>

            <div style="text-align:center;padding:10px 0">
                <button  class="btn btn-secondary btn_confirm" style="width:150px;height:40px" v-on:click="Close()">閉じる</button>
            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */

import { ref, watch } from 'vue'
import { GlobalData, DateSetting,TimeSetting,DateTimeSetting } from '../js/userdata.js'

// 親コンポーネント（UserPgShosai.vue）から送られてきた値
// set_nittei_list：選択した日付に関する日程リスト
// nittei_sentaku ：日程選択方法　0：時間帯ごと（従来）、1：日程まるごと
// teiin_settei   ：定員の扱い　0：時間帯ごと（従来）、1：1日ごと
// teiin_oneday   ：定員の扱いが1日ごとの場合の定員
// clicked        ：選択した日付
// moushikomi     ：申込める日時のリスト（選択した日付のもの）
// select_date    ：申込むユーザーがすでに選択したもの
// mode           ：ログインしてるかどうか
// katsudou       ：main（活動１） or sub（活動２～）
// katsudou_no    ：活動の番地（活動2＝0、活動3＝1…） ※活動1は9999で固定
// nittei_no      ：活動の中における日程の番地
// cancel_setting ：キャンセル待ち機能を利用する　0：する、1：しない
const props = defineProps(["param"])


let set_nittei_list = props.param.set_nittei_list
let nittei_sentaku = props.param.nittei_sentaku
let teiin_settei = props.param.teiin_settei
let teiin_oneday = props.param.teiin_oneday
let clicked = props.param.clicked
let moushikomi = props.param.moushikomi
let select_date = props.param.select_date
let mode = props.param.mode
let katsudou = props.param.katsudou
let katsudou_no = props.param.katsudou_no
let nittei_no = props.param.nittei_no
let cancel_setting = props.param.cancel_setting
console.log(props.param)

let moushikomi_list = []

if(nittei_sentaku == 1){
    moushikomi_list = moushikomi[0]
}

console.log(moushikomi)

let sentaku_list = []


    if(nittei_sentaku == 1){
        // 日程選択方法が日程まるごとの場合は存在したら選択済み（取り消し対象）
        for(let m = 0;m<moushikomi_list.length;m++){
            let set_length = sentaku_list.length

            sentaku_list[set_length] = moushikomi_list[m]
            sentaku_list[set_length].sentaku_flg = 0
            if(cancel_setting == 1){

                // キャンセル待ちを利用しないなら定員と参加人数の判定を入れる
                if(!moushikomi_list[m].teiin > moushikomi_list[m].ninzu){
                    sentaku_list[set_length].sentaku_flg = 2
                    // 満員ならここで終了
                    continue
                }
            }
            
            
            if(select_date.length != 0){
                for(let d = 0;d < select_date.length;d++){
                    if(select_date[d].kaisai_start == moushikomi_list[m].kaisai_start){
                        sentaku_list[set_length].sentaku_flg = 1
                    }
                }
            }
            
        }


    }else{
        // 日程選択方法が時間帯ごと（従来）の場合
        // 表示する日時に番号が存在する場合は選択済み（取り消し対象）
        for(let m = 0;m<moushikomi.length;m++){

            let set_length = sentaku_list.length

            sentaku_list[set_length] = moushikomi[m]
            sentaku_list[set_length].sentaku_flg = 0
            
            if(cancel_setting == 1){

                // キャンセル待ちを利用しないなら定員と参加人数の判定を入れる
                if(!moushikomi[m].teiin > moushikomi[m].ninzu){
                    sentaku_list[set_length].sentaku_flg = 2
                    // 満員ならここで終了
                    continue
                }
            }

            sentaku_list[set_length].sentaku_flg = 0
                
            if(select_date.length != 0){
                for(let d = 0;d < select_date.length;d++){
                    if(select_date[d].bango == moushikomi[m].all_count){
                        sentaku_list[set_length].sentaku_flg = 1
                    }
                }
            }
        }
    }

console.log(sentaku_list)

/* 親コンポーネントに関わる関数 */
const emit = defineEmits(['call'])


// 選択・取消ボタン押下（時間帯ごと）
let Check = function(i){
    // 選択した日時を送って閉じる
    if(katsudou == "main"){
        emit('call',{cmd:'set',date:clicked,moushikomi:sentaku_list[i],"nittei_no":nittei_no})
    }else{
        emit('call',{cmd:'sub_set',date:clicked,moushikomi:sentaku_list[i],"katsudou_no":katsudou_no,"nittei_no":nittei_no})
    }
}


// 日程丸ごと
let Check_list = function(){
    if(katsudou == "main"){
        emit('call',{cmd:'set_list',"nittei_no":nittei_no})
    }else{
        emit('call',{cmd:'sub_set_list',"katsudou_no":katsudou_no,"nittei_no":nittei_no})
    }

}



// 選択・取消ボタン押下
let Close = function(){
    // 閉じる
    emit('call',{cmd:'close'})
}



/* 初期処理 */

</script>

<style scoped>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#content_modal{
  /* 要素を重ねた時の順番 */
  z-index:2;
    width: 90%;
    max-width:340px;
    text-align: left;
    padding: 0.5em;
  background:#fff;
  white-space: pre-line;
}
.check_button{
    width:50px
}
#content_modal button{
    height: 45px;
    width:60px;
    padding: 0;
}

.select_row{
    padding:10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
</style>